<template>
  <div class="connect-with-us">  
          
    <div class="widget-li" ref="dropdownRef" @keydown.tab="handleTabKey">
      <button aria-labelledby="connect with us widget" slot="toggle" class="connectwithus-widget dropdown-toggle" @click="toggleDropdown" tabindex="0">
        <img :src="'/img/material-widgets.png'" alt="" class="img-connect"/>
        <span >{{languageData['connect_with_us']}}</span>
        
        </button>
      <div class="drop-nav" :class="{ 'drop-nav-normal': message === 'live-connect-normal' }" v-show="isDropdownOpen">
        <a v-if="scheduler_flag" class="drop-item" v-on:click.stop.prevent="callscheduler();calllog('online_scheduler_clicked');" href="#">
          <img alt="Scheduler" :src="LOCAL_HOST+'/img/scheduler_ico.png'" class="item-img"/>
          <div class="scheduler_span text-wrap">{{languageData['schedule_an_appointment']}}</div>
          <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow" :class="{ 'img-arrow-normal': message === 'live-connect-normal' }">
        </a>
        <a v-if="themeLogic.headers.live_connect" class="drop-item" v-on:click.stop.prevent="openNewWindow();calllog('live_connect_clicked');" href="#"> 
          <img alt="live connect chat with us" :src="LOCAL_HOST+'/img/live_connect_cosmic23x20.png'" class="item-img">
          <div class="text-wrap">{{languageData['chat']}}</div>
          <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow" :class="{ 'img-arrow-normal': message === 'live-connect-normal' }">
        </a>
        <template v-if="!themeLogic.additional_flag.turn_off_raise_an_issue">
        <a v-if="themeLogic.additional_flag.raise_an_issue_form" class="drop-item" href="/feedback/" @click="calllog('feedback_clicked');"> 
          <img :src="'/img/cross_icon.png'" alt="" class="item-img">
          <div class="text-wrap">{{languageData['concern_form']}}</div>
          <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow" :class="{ 'img-arrow-normal': message === 'live-connect-normal' }">
        </a>
        <div v-else class="drop-item" @click="qualtricsOpen;calllog('qualtrics_feedback_clicked');"> 
          <img :src="'/img/cross_icon.png'" alt="" class="item-img">
          <div id="qaltrics_popup" class="text-wrap"></div>
          <input type="hidden" :value="ucms_id_scheduler" id="ucms_id" name="ucms_id"/>
          <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow">
        </div>
        </template>
        <template v-for="(connect,ky) in connect_us">
          <a class="drop-item" v-if="connect['url_external']=='0' && connect['open_new_window'] == '0'" :href="LOCAL_HOST+connect['url']" :key="ky" @click="calllog(connect['webhit_log_name']+'_clicked');">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div class="text-wrap">{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow" :class="{ 'img-arrow-normal': message === 'live-connect-normal' }">
          </a>
          <a class="drop-item" v-if="connect['url_external']=='0' && connect['open_new_window'] == '1'" href="#" target="_blank" v-on:click.stop.prevent="newWindowOpen(LOCAL_HOST+connect['url']);calllog(connect['webhit_log_name']+'_clicked');">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div class="text-wrap">{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow" :class="{ 'img-arrow-normal': message === 'live-connect-normal' }">
          </a>
          <a class="drop-item" v-if="connect['url_external']=='1' && connect['open_new_window'] == '0'" :href="connect['url']" @click="calllog(connect['webhit_log_name']+'_clicked');">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div class="text-wrap">{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow" :class="{ 'img-arrow-normal': message === 'live-connect-normal' }">
          </a>
          <a class="drop-item" v-if="connect['url_external']=='1' && connect['open_new_window'] == '1'" href="#" target="_blank" v-on:click.stop.prevent="newWindowOpen(connect['url']);calllog(connect['webhit_log_name']+'_clicked');">
            <img :src="connect['iconImg']" :alt="languageData[connect['title']]" class="item-img">
            <div class="text-wrap">{{languageData[connect['title']]}}</div>
            <img :src="LOCAL_HOST+'/img/right_arrow.png'" alt="" class="img-arrow" :class="{ 'img-arrow-normal': message === 'live-connect-normal' }">
          </a>
        </template>
      </div>
    </div>
   
  </div>

</template>

<script>
import axios from 'axios';
// import {  mdbNavbarToggler, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle } from 'mdbvue';


export default {
    name: 'ConnectwithUs',
    data(){
        return{
          CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN, 
          FORM_ACTION_DOMAIN:this.$store.state.FORM_ACTION_DOMAIN, 
          LOCAL_HOST:this.$store.state.LOCAL_HOST,
          lang_id:localStorage.id_language,
          scheduler_flag:0,
          //ucms_id_scheduler:this.$store.state.companyDataInfo.ucms_company,
          ucms_id_scheduler:localStorage.ucms_company,
          not_inAppointmentType:[],
          availabilityInfoMessage:"",
          company_data:[],
          connect_us: [],
           isDropdownOpen: false
        };
    },
    props: ['message'],
     components: {
            //  mdbNavbarToggler, 
            //  mdbDropdown, 
            //  mdbDropdownMenu, 
            //  mdbDropdownToggle 
        }, 
    computed:{
      languageData(){return this.$store.state.languageData;},
      themeLogic(){return this.$store.state.themeLogic;},
      companyDataInfo(){return this.$store.state.companyDataInfo},
      liveConnectCsAr(){ if(this.lang_id=='043') {return ' live-connect-cs-ar'}else{return '';}},
      schedulerCsAr(){ if(this.lang_id=='043') {return ' scheduler-cs-ar'}else{return '';}}
    },
    mounted: function () {
      if(this.$store.state.companyDataInfo['id_customizations']=="" || this.$store.state.companyDataInfo['id_customizations']==undefined || this.$store.state.companyDataInfo['id_customizations']=='undefined'){
          this.getCompanyData();
      }else{
          this.company_data['id_customizations']=this.$store.state.companyDataInfo['id_customizations'];
          this.schedulerCheck();
      } 
      this.connectusCheck();  
      
    },
    created:function(){
        this.addQualtrics();
    },
	  methods:{
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        this.calllog('connect_with_us_panel_clicked');       
        if(document.getElementById("qaltrics_popup")){
          let par = document.getElementById("qaltrics_popup");
          if(par.children.length){
            par.children[0].text=this.$store.state.languageData['concern_form'];
          }
        }
        // Add global click event listener when the dropdown is opened
        document.addEventListener('click', this.handleClickOutside);
      } else {
        // Remove global click event listener when the dropdown is closed
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    handleClickOutside(event) {
      // Close the dropdown if the click is outside of it
      if (!this.$refs.dropdownRef.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
      handleTabKey(event) {
      // Close the dropdown when tabbing away from the last item
      if (event.key === 'Tab' && !event.shiftKey && !event.ctrlKey && !event.altKey) {
        const dropdownItems = this.$refs.dropdownRef.querySelectorAll('.drop-item');
        const lastItem = dropdownItems[dropdownItems.length - 1];
        if (document.activeElement === lastItem) {
          this.isDropdownOpen = false;
        }
      }
    },
   
      
      openNewWindow:function(){
          var link='https://rms.workplaceoptions.com/anonymouschat/'+this.companyDataInfo['rms_system']+"/"+this.companyDataInfo['rms_company']+"/"+this.companyDataInfo['rms_service']+"/"+this.companyDataInfo['id_language_rms']+"?id_company="+this.$store.state.companyData['id_company']+"&name_company="+this.$store.state.companyData['name_company'];
          //console.log("getting here"+screen.width+'-h-'+screen.height);             
          window.open(link,'menu', 'location');                
      },
      newWindowOpen(goto){
        window.open(goto,'menu', 'location');
      },
      callscheduler(o,t){
          //console.log('not_inAppointmentType-',this.ucms_id_scheduler);
          window.psObject.initProviderScheduler({
              position:"bottom-right",
              providerName:o,
              providerAddress:t,
              ucmsCompanyId:this.ucms_id_scheduler,
              notInAppointmentType:this.not_inAppointmentType,
              availabilityInfoMessage:this.availabilityInfoMessage,
              websiteId:this.$store.state.companyData['id_company'],
              webLanguageId:this.$store.state.companyData['id_language'],
              webCountryId:this.$store.state.companyData['id_country'],
              websiteEap:this.$store.state.companyData['id_eap']
          })
      },
      getCompanyData(){        
          var api_private_key=this.get_api_key_mix('cofo')
          axios.get(this.$store.state.apiUrl+'/company_info',{
              params:{
                  id_company:this.$store.state.companyData['id_company'] ,
                  id_language:this.$store.state.companyData['id_language'],
                  id_country:this.$store.state.companyData['id_country'],                    
                  privatekey:api_private_key
                  }
              })
          .then(response => {
              response = response.data;
              this.company_data['id_customizations'] = response['id_customizations'];
              this.schedulerCheck();          
              })
          .catch((error) => {
              this.company_data = [];
              this.company_data['id_customizations']=this.$store.state.companyDataInfo['id_customizations'];
              this.schedulerCheck(); 
              this.customErrorHandler(error.response.status);
              });
      },
      schedulerCheck(){
          axios.get(this.$store.state.apiUrl+'/scheduler_widget_config',{
              params:{
                  id_language:this.$store.state.companyData['id_language'],
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'],
                  id_customization:this.company_data['id_customizations']
              }
          })
          .then(response => {
              this.ucms_id_scheduler=localStorage.ucms_company;
              response = response.data;
              this.scheduler_flag = response.flag;
              if(response.ucms_id!=""){
                  this.ucms_id_scheduler=response.ucms_id;
              }
              this.not_inAppointmentType=response.not_in_appointment_type;
              this.availabilityInfoMessage=response.availabilityInfoMessage;
          })
          .catch(() => {
              //console.log('sched-err-came-custID:',this.company_data['id_customizations']);
              this.scheduler_flag = 0;
          });
      },
      connectusCheck(){
          var api_private_key=this.get_api_key_mix('geig') 
          axios.get(this.$store.state.apiUrl+'/get_connect_panel_config',{
              params:{
                  id_language:this.$store.state.companyData['id_language'],
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'],
                  privatekey:api_private_key
              }
          })
          .then(response => {
              this.connect_us = response.data;
          })
          .catch(() => {
              //console.log('sched-err-came-custID:',this.company_data['id_customizations']);
              this.connect_us = [];
          });
      },
     qualtricsOpen(){
        let par = document.getElementById("qaltrics_popup");
        par.children[0].click();
      },
      addQualtrics() { 
        axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_company+"_"+localStorage.id_country+localStorage.id_language+".php",{  
          })
        .then(response => {
            this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_company+"_"+localStorage.id_country+localStorage.id_language+".php");     
          })
        .catch((error) => {
            axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_company+".php",{  
              })
            .then(response => {
                this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_company+".php");     
              })
            .catch((error) => {
                axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_eap+"_"+localStorage.id_country+localStorage.id_language+".php",{  
                  })
                .then(response => {
                    this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_eap+"_"+localStorage.id_country+localStorage.id_language+".php");     
                  })
                .catch((error) => {
                    axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_eap+".php",{  
                      })
                    .then(response => {
                        this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_eap+".php");     
                      })
                    .catch((error) => {
                        axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_country+localStorage.id_language+".php",{  
                          })
                        .then(response => {
                            this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics_"+localStorage.id_country+localStorage.id_language+".php");     
                          })
                        .catch((error) => {
                          console.log('only qualtrics');
                            this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/qualtrics/qualtrics"+".php");
                          });
                      });
                  });
              }); 
          });
      },
      calllog(widgetName){
        this.web_hits(widgetName);
      }
    }
};
</script>
<style scoped>

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  background-color: #f1f1f1;
  border: none;
  /* padding: 10px; */
}

.dropdown-menu {
  display: none;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-item {
  color: #333;
  padding: 10px;
  text-decoration: none;
  display: block;
}

.dropdown-item:hover {
  background-color: #f9f9f9;
}

.dropdown-toggle:hover + .dropdown-menu {
  display: block;
}
@media only screen  and (min-width : 992px) {
.side {
    margin-bottom: 0 !important;
    }
}
.parent {
  width: 90%;
  float: right;
  background: #02437d;
  padding: 10px 8px 1px 8px;
  border-radius: 12px;
}
@media only screen and (max-width: 1280px) and (min-width: 993px) {
  .parent {
    width: 100% !important;
}
}
@media only screen and (max-width: 992px) and (min-width: 768px){
  .parent {
    width: 100% !important;
  }  
}
@media only screen and (max-width: 767px) and (min-width: 576px) {
 
  .parent {
    width: 100% !important;
  }
}
@media only screen and (max-width: 576px) { 
  .parent {
    width: 100% !important;
  }
}
@media only screen and (max-width: 768px) {
    .drop-nav-normal {
    left: 78px;
    top: 38px;
    min-width: auto;
    
  }
}
.connectwithus-widget{
  display: block;
  height: 40px;
  background:#0F2D59;
  /* background-image: url('/img/material-widgets.png'); */
  background-repeat: no-repeat;
  background-position: 20px 10px;
  color: #FFF;
  min-width: 200px;
  float: right;
  border-radius: 0;
  /* margin-top: -3px; */
}
.img-connect {
  padding-right: 10px;
  margin-top: -8px;
}
.connect-with-us {
  margin-top: 31px;
  position: relative;
}
.dropdown-toggle::after {
    display: none !important;
  }
/* .drop-nav {
    min-width: 340px;
    padding: 17px;
    left: -137px;
    position: absolute;
    background: #fff;
    top: -120px;
    z-index: 999;
    top:41px;
    left:90px;
     /* top: auto; */ /* Reset top position */
  /* bottom: 100%;  *//* Position above the button */
  /* -webkit-box-shadow: transparent 0 0 0 0, transparent 0 0 0 0, rgba(0,0,0,.1) 0 4px 6px -1px, rgba(0,0,0,.06) 0 2px 4px -1px;
    box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 0px 6px 1px rgba(0,0,0,0.15), 0px 2px 6px -1px rgba(0,0,0,.06); */
  /* } */ 

  .drop-nav {
    min-width: 200px;
    padding: 17px;
    /* left: 90px; */
    position: absolute;
    background: #fff;
    top: 41px;
    z-index: 999;
    right: 0px;
     /* top: auto; Reset top position */
  /* bottom: 100%; Position above the button */
  -webkit-box-shadow: transparent 0 0 0 0, transparent 0 0 0 0, rgba(0,0,0,.1) 0 4px 6px -1px, rgba(0,0,0,.06) 0 2px 4px -1px;
    box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 0px 6px 1px rgba(0,0,0,0.15), 0px 2px 6px -1px rgba(0,0,0,.06);
  }

  .drop-nav-normal {
    left: -38px;
    top: 38px;
    min-width: auto;
    bottom: auto !important;
  }
  .drop-item {
    position: relative;
    padding: 7px 0;
    display: flex;
    align-items: center;
    cursor:pointer;
  }
  .img-arrow {
    position: absolute;
    right: -10px;
    top: 15px;
  }
  .item-img {
    padding-right: 15px;
    /* width: 20px; */
    height: 20px;
  }
/* @media only screen and (max-width: 400px)   {

} */
/* @media only screen and (max-width: 576px) and (min-width: 401px)  {
 
   .drop-nav-normal {
    left: -38px;
    top: 38px;
    min-width: auto !important;
  }
  .text-wrap{
  width: 100%;
  white-space: normal;
  text-align: left;
 
}
} */
.text-wrap{
  width: 100%;
  white-space: normal;
  text-align: left;
 
}
/* .connect-with-us:has(.drop-nav:empty) {
  display: none;
} */
</style>
